import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { Row, Spin, Typography, theme } from 'antd'

// components
import Button from '../../../components/button/button'

// slices
import {
    profileState,
    switchIntroductionModal,
    switchProfileModal,
    switchVideoPlayModal,
} from '../profile.slice'
import { loginState } from '../../login/login.slice'

// assets
import { NoVideosIcon, VideosIcon } from '../../../assets/icons'

// constants
import { videosTitle } from '../../../constants/profile'
import { SUPER_ADMIN } from '../../../constants/roles'

// sections
import NoIndividualContent from '../tabSection/noIndividualContent'

// styles
import tabStyles from '../profileTabContent.module.css'

function VideosTabContent() {
    const { Title } = Typography

    const { useToken } = theme
    const { token } = useToken()

    const dispatch = useDispatch()

    const {
        profileData: {
            data: { videos },
        },
        status,
        introductionVideoModal,
        defaultTab,
    } = useSelector(profileState)
    const { userProfile } = useSelector(loginState)

    // VIDEO SET INITIALLY
    useEffect(() => {
        if (videos?.length > 0) {
            const results = videos.filter(({ type: id1 }) =>
                videosTitle.some(({ key: id2 }) => id2 === id1)
            )
            dispatch(
                switchIntroductionModal({
                    ...introductionVideoModal,
                    open: false,
                    videosTab: results,
                })
            )
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [videos, defaultTab])

    return (
        <div className={tabStyles.panel}>
            <Row align="middle" justify={'space-between'}>
                <Title level={4} className={tabStyles.panelTitle}>
                    Videos
                </Title>
                {userProfile?.role?.roleName !== SUPER_ADMIN && (
                    <Button
                        props={{
                            text: 'Add Videos',
                            onClick: () => {
                                dispatch(
                                    switchProfileModal({
                                        name: 'videos',
                                        open: true,
                                    })
                                )
                            },
                        }}
                    />
                )}
            </Row>
            <Spin spinning={status === 'loading' ? true : false}>
                {status === 'loaded' && videos?.length > 0 ? (
                    <div className={tabStyles.mediaGrid}>
                        {videos.map((videosData) => (
                            <div
                                className={tabStyles.mediaCard}
                                key={videosData?._id || videosData?.type}
                            >
                                <div className={tabStyles.videoWrap}>
                                    <video
                                        src={videosData?.link}
                                        className={tabStyles.mediaThumb}
                                        preview={false}
                                    />
                                    <div
                                        className={tabStyles.playOverlay}
                                        onClick={() => {
                                            dispatch(
                                                switchVideoPlayModal({
                                                    delete: true,
                                                    videoData: {
                                                        deleteId:
                                                            videosData?._id,
                                                        link: videosData.link,
                                                    },
                                                    open: true,
                                                    title: videosData?.type,
                                                })
                                            )
                                        }}
                                    >
                                        <VideosIcon
                                            color={
                                                token.colorPalette.textColor
                                                    .quinary
                                            }
                                        />
                                    </div>
                                </div>
                                <div className={tabStyles.mediaBody}>
                                    <Row justify={'space-between'}>
                                        <Title
                                            className={`${tabStyles.mediaTitle} titleSub`}
                                        >
                                            {videosData?.type || 'N/A'}
                                        </Title>
                                        {/* {userProfile?.role?.roleName !==
                                            SUPER_ADMIN && (
                                            <div
                                                className={tabStyles.editBtn}
                                                onClick={() => {
                                                    dispatch(
                                                        setDeleteModalTitle(
                                                            'video'
                                                        )
                                                    )
                                                    dispatch(
                                                        switchVideoPlayModal({
                                                            delete: true,
                                                            videoData: {
                                                                deleteId:
                                                                    introductionVideoModal
                                                                        ?.videosTab
                                                                        ?.length >
                                                                        0 &&
                                                                    introductionVideoModal?.videosTab.find(
                                                                        (
                                                                            data
                                                                        ) =>
                                                                            data?.type ===
                                                                            videosData?.type
                                                                    )?._id,
                                                                link:
                                                                    introductionVideoModal
                                                                        ?.videosTab
                                                                        ?.length >
                                                                        0 &&
                                                                    introductionVideoModal?.videosTab.find(
                                                                        (
                                                                            data
                                                                        ) =>
                                                                            data?.type ===
                                                                            videosData?.type
                                                                    )?.link,
                                                            },
                                                            open: true,
                                                            title: videosData?.type,
                                                        })
                                                    )
                                                }}
                                            >
                                                <EditIcon />
                                            </div>
                                        )} */}
                                    </Row>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : status === 'loaded' ? (
                    <NoIndividualContent
                        content={{
                            key: 'videos',
                            title: 'Videos',
                            icon: <NoVideosIcon />,
                        }}
                    />
                ) : (
                    status === 'loading' && <Spin />
                )}
            </Spin>
        </div>
    )
}

export default VideosTabContent
